module.exports = __webpack_public_path__ + "static/media/terreno_campo.049ad99b.svg";